import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  CardContent,
  Button,
  Typography,
  TextField,
  Select,
  MenuItem,
  ExpansionPanel ,
  ExpansionPanelSummary,
  Table,
  TableBody,
} from "@material-ui/core";
import MapContainer from "../MapContainer";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import { selectReport } from "./selectors";
import { getReport, setReport, getJobPackReports } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";
import styled from "styled-components";
import "../reports.css";
import PrintIcon from "@material-ui/icons/Print";

import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
const ActionButton = styled(Button)`
  @media print {
    visibility: hidden;
  }
`;
let checkedit = "";
class OfficeInspectionReport extends Component {
  constructor(props) {
    super(props);
    let path = props.location.pathname.split("/");
    checkedit = path[1];
    this.state = {
      imageModal: false,
      selectedImg: false,
      report: false,
      editing:
        path[1] === "report-view"
          ? false
          : path[1] === "report-view-standalone"
            ? false
            : true,
      title: document.title,
      reportType: path[4].replace(/-/g, "_"),

    };

    if (path[2] === "reports") {
      props.getReport(
        path[2].replace(/-/g, "_"),
        path[3],
        path[4].replace(/-/g, "_"),
        path[5].replace(/_/g, " ").replace(/\./g, ":")
      );
    } else {
      props.getJobPackReports(
        props.match.params.uid,
        path[2].replace(/-/g, "_"),
        path[3],
        path[4].replace(/-/g, "_"),
        path[5].replace(/-/g, "_"),
        path[7].replace(/-/g, "_"),
        props.match.params.report_id.replace(/_/g, " ").replace(/\./g, ":")
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.report !== prevProps.report) {
      this.setState({ report: this.props.report });
    }
  }
  renderInspection = (key, value = false) => {
    let col = "green";
    value === "Amber"
      ? (col = "green")
      : value === "U"
        ? (col = "orange")
        : value === "I"
          ? (col = "red")
          : (col = "grey");
    if (this.state.editing) {
      return (
        <Select
          value={
            this.state.report[key] === undefined
              ? false
              : this.state.report[key]
          }
          onChange={(event) => {
            let report = {
              ...this.state.report,
              [key]: event.target.value,
            };
            this.setState({ report });
          }}
          style={{ minWidth: "100%", background: col }}
        >
          <MenuItem value={"A"} style={{ background: "green" }}>
            A
          </MenuItem>
          <MenuItem value={"U"} style={{ background: "orange" }}>
            U
          </MenuItem>
          <MenuItem value={"I"} style={{ background: "red" }}>
            I
          </MenuItem>
          <MenuItem value={"N/R"} style={{ background: "grey" }}>
            N/R
          </MenuItem>
        </Select>
      );
    } else {
      return <div style={this.statusStyle(value)}>{value}</div>;
    }
  };
  renderText = (key, value) => {
    if (this.state.editing) {
      return (
        <TextField
          value={this.state.report[key]}
          onChange={event => {
            let report = {
              ...this.state.report,
              [key]: event.target.value
            };
            this.setState({ report });
          }}
        />
      );
    } else {
      return value;
    }
  };
  renderText1 = key => {
    if (this.state.editing) {
      return (
        <TextField
          value={key}
        // onChange={event => {
        //     let report = {
        //         ...this.state.report,
        //         [key]: event.target.value
        //     };
        //     this.setState({ report });
        // }}
        />
      );
    } else {
      return key;
    }
  };
  renderDropDown = (key, value, opts) => {
    if (this.state.editing) {
      return (
        <Select
          style={{ width: "100%" }}
          value={this.state.report[key] === "" ? "N/A" : this.state.report[key]}
          onChange={event => {
            let report = {
              ...this.state.report,
              [key]: event.target.value
            };
            this.setState({ report });
          }}
        >
          <MenuItem value="N/A">N/A</MenuItem>
          {opts.map(option => {
            return (
              <MenuItem value={option} key={option}>
                {option}
              </MenuItem>
            );
          })}
        </Select>
      );
    } else {
      return value === "" ? "N/A " : value;
    }
  };
  statusStyle = (value) => {
    let color = "black";
    let background = "white";

    if (value === "Amber") {
      background = "orange";
    } else if (value === "Green") {
      background = "#2ecc71";
    } else if (value === "Red") {
      background = "red";
    } else {
      background = "grey";
    }
    return { minWidth: "100%", padding:"8px", minHeight: "100%", color, background, textAlign: "center", borderRadius:"8px", boxShadow:" 0 8px 6px -6px black" };
  };
  renderSignatures(attachedSignatures) {
    let photoRow = 2;
    let photoCell = 1;
    return attachedSignatures.map((sig, i) => {
      let photoInfo = (
        <React.Fragment key={i}>
          <div
            style={cellStyle(photoRow, photoCell, photoRow, photoCell, true)}
          >
            {sig.signature_name}
          </div>
          <div
            style={cellStyle(
              photoRow,
              photoCell + 1,
              photoRow,
              photoCell + 1,
              true
            )}
          >
            {sig.signature_timestamp}
          </div>
          <div
            style={cellStyle(
              photoRow + 1,
              photoCell,
              photoRow + 1,
              photoCell + 2
            )}
          >
            <img
              src={sig.signature_url}
              alt="Site "
              onClick={() => {
                this.setState({
                  selectedPhoto: sig,
                  imageModal: true
                });
              }}
              style={{
                width: 100,
                height: 100,
                margin: "auto",
                cursor: "pointer"
              }}
            />
          </div>
        </React.Fragment>
      );
      photoCell += 2;
      if (photoCell === 9) {
        photoRow += 2;
        photoCell = 1;
      }
      return photoInfo;
    });
  }

  renderSignature(attachedSignature) {
    let photoRow = 2;
    let photoCell = 1;
    
      let photoInfo = (
        <React.Fragment key={attachedSignature.timestamp}>
          <div
            style={cellStyle(photoRow, photoCell, photoRow, photoCell, true)}
          >
            {attachedSignature.signature_name}
          </div>
          <div
            style={cellStyle(
              photoRow,
              photoCell + 1,
              photoRow,
              photoCell + 1,
              true
            )}
          >
            {attachedSignature.signature_timestamp}
          </div>
          <div
            style={cellStyle(
              photoRow + 1,
              photoCell,
              photoRow + 1,
              photoCell + 2
            )}
          >
            <img
              src={attachedSignature.signature_url}
              alt="Site "
              onClick={() => {
                this.setState({
                  selectedImg: attachedSignature.signature_url,
                  imageModal: true
                });
              }}
              style={{
                width: 100,
                height: 100,
                margin: "auto",
                cursor: "pointer"
              }}
            />
          </div>
        </React.Fragment>
      );
      photoCell += 2;
      if (photoCell === 9) {
        photoRow += 2;
        photoCell = 1;
      }
      return photoInfo;
    
  }

  renderPhotos(attachedPhotos) {
    let photoRow = 2;
    let photoCell = 1;
    return attachedPhotos.map((photo, i) => {
      let photoInfo = (
        <React.Fragment key={i}>
          <div
            style={cellStyle(photoRow, photoCell, photoRow, photoCell, true)}
          >
            {photo.photo_name}
          </div>
          <div
            style={cellStyle(
              photoRow,
              photoCell + 1,
              photoRow,
              photoCell + 1,
              true
            )}
          >
            {photo.photo_timestamp}
          </div>
          <div
            style={cellStyle(
              photoRow + 1,
              photoCell,
              photoRow + 1,
              photoCell + 2
            )}
          >
            <img
              src={photo.photo_url}
              alt="Site "
              onClick={() => {
                this.setState({
                  selectedPhoto: photo,
                  imageModal: true
                });
              }}
              style={{
                width: 300,
                height: 300,
                margin: "auto",
                cursor: "pointer"
              }}
            />
          </div>
        </React.Fragment>
      );
      photoCell += 2;
      if (photoCell === 9) {
        photoRow += 2;
        photoCell = 1;
      }
      return photoInfo;
    });
  }
  render() {
    //let report = this.props.report === false ? false : this.props.report;
    //  let dp = this.renderDropDown;

    let gstyle = gridStyle;
    let cstyle = cellStyle;

    const {  report, selectedImg } = this.state;
    return (
      <Card>
        <StyledHeader style={{ background: "#0188cc" }}>
          <Typography variant="headline" style={{ color: "white" }}>Office Inspection Report
          <ReactToPrint
            onBeforePrint={() => {
              setTimeout(undefined, 2000);
              document.title =
                "Examination Report- " +
                this.props.match.params.report_id
                  .replace(/_/g, " ")
                  .replace(/\./g, ":");
            }}
            onAfterPrint={() => {
              document.title = this.state.title;
            }}
            trigger={() => (
              <PrintIcon
                style={{
                  fontSize: "36px",
                  marginRight: "30px",
                  float: "right",
                  color: "white"
                }}
                color="primary"
                variant="contained"
                
              />
            )}
            content={() => this.componentRef}
          />
          </Typography>
        </StyledHeader>
        <CardContent>
         
          {report && (
            <>
              <div ref={el => (this.componentRef = el)}>
                {this.props.header && <this.props.header />}
                <div
                  className="imgDiv"
                  style={{
                    float: "left",
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between"
                  }}
                >
                  <Typography variant="headline">
                    Office Inspection Report
                  </Typography>
                </div>
                <div style={{ width: "100%" }}>
                  <div style={{ width: "45%", float: "left" }}>
                    <div style={gstyle(5, 13)}>
                      <div style={cstyle(1, 1, 1, 13, false, true)}>
                        <b>Report Details</b>
                      </div>
                      <div style={cstyle(2, 1, 2, 13)}>
                        <b>Name: </b>&nbsp; {report.user_name ? report.user_name : "N/A"}
                      </div>
                      <div style={cstyle(3, 1, 3, 13)}>
                        <b>Email:</b>&nbsp; {report.user_email ? report.user_email : "N/A"}
                      </div>
                      <div style={cstyle(4, 1, 4, 13)}>
                        <b>Date and Time: </b>&nbsp;{report.timestamp ? report.timestamp : "N/A"}
                      </div>
                      <div style={cstyle(5, 1, 6, 13)}>
                        <b>Area: </b>&nbsp;{report.area}
                      </div>
                      <div style={cstyle(6, 1, 7, 13)}>
                        <b>Department: </b>&nbsp; {report.department}
                      </div>
                      <div style={cstyle(7, 1, 8, 13)}>
                        <b>Directorate: </b>&nbsp; {report.directorate}
                      </div>
                      <div style={cstyle(8, 1, 8, 13)}>
                        <b>Section: </b>&nbsp; {report.section}
                      </div>
                      <div style={cstyle(9, 1, 9, 13)}>
                        <b>Job Address: </b>&nbsp; {report.location}
                      </div>
                      <div style={cstyle(10, 1, 10, 13)}>
                        <b>Inspection Of: </b>&nbsp; {report.inspection_of}
                      </div>
                      <div style={cstyle(11, 1, 11, 13)}>
                        <b>Inspection By: </b>&nbsp; {report.inspection_carried_out_by}
                      </div>
                      <div style={cstyle(12, 1, 12, 13)}>
                        <b>Line Manager: </b>&nbsp; {report.line_manager}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      float: "left",
                      marginLeft: "2%",
                      width: "53%",
                      zIndex: "500"
                      // height:
                      //     this.infoDiv === undefined
                      //         ? 0
                      //         : this.infoDiv
                      //             .offsetHeight - 10
                    }}
                  >
                    <MapContainer
                      lat={+report.location_lat}
                      long={+report.location_lon}
                    />
                  </div>
                </div>
                {/* <div style={{ width: "100%",clear: "both" }}>
                  <div style={{ width: "100%", float: "left" }}>
                    <div style={gstyle(5, 13)}>
                      <div style={cstyle(1, 1, 1, 13, false, true)}>
                        <b>Inspection Type</b>
                      </div>
                      <div style={cstyle(2, 1, 2, 13)}>
                        <b>Inspection Type: </b>
                      </div>
                      <div style={cstyle(2, 2, 2, 13, true)}>
                        {report.inspection_type ? report.inspection_type : "N/A"}
                      </div>
                    </div>
                    </div>
                  </div> */}

                <div style={{ width: "100%", clear: "both" }}>
                  <div style={gstyle(4, 4)}>
                    <div style={cstyle(1, 1, 1, 4, false, true)}>
                      <b>Rating Code Table</b>
                    </div>
                    <div style={cstyle(2, 1, 2, 1)}>
                      <b>Ref No.:</b>
                    </div>
                    <div style={cstyle(2, 2, 2, 2)}>
                      <b>Colour Code:</b>
                    </div>
                    <div style={cstyle(2, 3, 2, 4)}>
                      <b>Definition:</b>
                    </div>
                    <div style={cstyle(3, 1, 3, 1)}>1</div>
                    <div style={cstyle(3, 2, 3, 2)}>
                      <div style={this.statusStyle("Green")}>Green</div>
                    </div>
                    <div style={cstyle(3, 3, 3, 4)}>
                      No Issue Detected
                  </div>
                    <div style={cstyle(4, 1, 4, 1)}>2</div>
                    <div style={cstyle(4, 2, 4, 2)}>
                      <div style={this.statusStyle("Amber")}>Amber</div>
                    </div>
                    <div style={cstyle(4, 3, 4, 4)}>
                    Improvement Required 
                  </div>
                    <div style={cstyle(5, 1, 5, 1)}>3</div>
                    <div style={cstyle(5, 2, 5, 2)}>
                      <div style={this.statusStyle("Red")}>Red</div>
                    </div>
                    <div style={cstyle(5, 3, 5, 4)}>
                      Critical Issue Detected
                  </div>
                    <div style={cstyle(6, 1, 6, 1)}>4</div>
                    <div style={cstyle(6, 2, 6, 2)}>
                      <div style={this.statusStyle("N/A")}>N/A</div>
                    </div>
                    <div style={cstyle(6, 3, 6, 4)}>
                      N/A
                  </div>
                  </div>
                </div>
                <div style={{ clear: "both", width: "100%" }}>
                <ExpansionPanel defaultExpanded={true}>
                  <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      style={{ backgroundColor: "#0188cc", borderRadius: "6px", fontSize: "22px", width: "100%" }}
                    >
                      <h3 style={{
                        textAlign: "center",
                        padding: "4px",
                        fontWeight: "bold",
                        color: "white",
                        borderRadius: "6px",
                        fontSize: "22px",
                      }}>
                        Inspection 
                      </h3>
                    </ExpansionPanelSummary>
                    <Table>
                        <TableBody>
                          {report.sections && report.sections.map((e, i) => {
                            return (
                              <Row key={i}>
                                <div className="icon-text-container" 
                                style={{ 
                                         borderWidth: "medium", 
                                         border: "2px solid #0188cc", 
                                         borderRadius: "9px", 
                                         marginTop: "10px",
                                         width: "97%" ,
                                         margin: "auto"
                                         }} >
                                  <div>
                                    <div style={{
                                          backgroundColor: "#0188cc"
                                    }}>
                                      <h5
                                        style={{
                                          padding: "7px",
                                          fontSize: "1em",
                                          textAlign: "center",
                                          color: "white"
                                        }}
                                      >
                                        <b >Section title:</b> <span className="subHeading">{e.title}</span>
                                      </h5>
                                    </div>
                                  </div>
                                  <div>
                                    {e.items && e.items.map((k, j) => {
                                      return (
                                        <Row key={j} style={{ marginLeft: "auto" }}>
                                          <div
                                            className="icon-text-container"
                                            style={{
                                              borderWidth: "medium",
                                              border: "2px solid #0188cc",
                                              borderRadius: "9px",
                                              //marginLeft:"150px",
                                              margin: "auto",
                                              width: "97%",
                                              padding: "10px",
                                              marginBottom: "10px",
                                              boxShadow: "0 8px 6px -6px black"
                                            }}
                                          >
                                            <p style={{ marginLeft: "10px" }}>
                                              <b> {k.title} </b>
                                            </p>
                                            <div
                                              className="icon-text-container"
                                              style={{
                                                borderWidth: "medium",
                                                marginTop: "10px",
                                                marginLeft: "10px",
                                                marginRight: "10px",
                                                marginBottom: "10px",
                                                display: "flex"
                                              }}
                                            >
                                              <p>

                                                <div style={this.statusStyle(k.result)}><b>Status:&nbsp;</b>{k.result}</div>

                                              </p>
                                              <div className="clear"></div>
                                            </div>
                                            {k.result === "Green" || k.result === "NA"
                                              ?
                                              ""
                                              :
                                              <>
                                                <div>
                                                {k.issue  ?  <p style={{ marginLeft: "10px" }}><b>Issue :&nbsp;</b>{k.issue} </p> : ""}
                                                {k.action ? <p style={{ marginLeft: "10px",marginTop:"-5px" }}><b>Action :&nbsp;</b>{k.action} </p> : ""}
                                                {k.assigned_to ?  <p style={{ marginLeft: "10px",marginTop:"-5px" }}><b>Assigned To :&nbsp;</b> {k.assigned_to} </p> : ""}
                                                {k.action_by ?  <p style={{ marginLeft: "10px",marginTop:"-5px" }}><b>Action By  :&nbsp;</b>{k.action_by}</p>  : ""}
                                                </div>
                                              </>
                                            }
                                            {k.result === "N/A"
                                              ?
                                              <div>
                                                <p style={{ marginLeft: "10px",marginTop:"-5px" }}><b>Reason :&nbsp;</b>{k.na_reason ? k.na_reason : "N/A"}</p>
                                                <p style={{ marginLeft: "10px",marginTop:"-5px" }}><b>Answer :&nbsp;</b>{k.na_answer ? k.na_answer : "N/A"}</p>

                                              </div>
                                              :
                                              <>

                                              </>
                                            }

                                          </div>
                                        </Row>
                                      );
                                    })}
                                  </div>
                                  
                                </div>
                              </Row>
                            );
                          })}
                        </TableBody>
                      </Table>
                </ExpansionPanel>
                </div>


                <div style={{ width: "100%", clear: "both", marginTop: "5px" }}>
                  <div style={{ width: "100%", float: "left" }}>
                    <div style={gstyle(6, 13)}>
                      <div style={cstyle(1, 1, 1, 13, false, true)}>
                        <b>General Information</b>
                      </div>
                      <div style={cstyle(2, 1, 2, 13)}>
                        <b>General Observations & Comments: </b>&nbsp; {report.general_comments ? report.general_comments : "N/A"}
                      </div>
                      <div style={cstyle(3, 1, 3, 13)}>
                        <b>Final Date For Corrective Action (Red): </b>&nbsp; {report.final_date_red ? report.final_date_red : "N/A"}
                      </div>
            
                      <div style={cstyle(4, 1, 4, 13)}>
                        <b>Final Date For Corrective Action (Amber): </b>&nbsp; {report.final_date_amber ? report.final_date_amber : "N/A"}
                      </div>
                 
                      <div style={cstyle(5, 1, 4, 13)}>
                        <b>Actions Inputted to LA SMS Audit System: </b>&nbsp; {report.input_to_la_sms_system ? report.input_to_la_sms_system : "N/A"}
                      </div>
    
                    </div>
                  </div>
                </div>
                
                <div style={gstyle(5, 10)}>
                  <div style={cstyle(1, 1, 1, 1, false, true)}>
                    <b>Inspectior Signature</b>
                  </div>
                  {report.inspector_signature &&
                    this.renderSignature(report.inspector_signature)}
                </div>
                
                <div style={gstyle(5, 10)}>
                  <div style={cstyle(1, 1, 1, 1, false, true)}>
                    <b>Line Manager Signature</b>
                  </div>
                  {report.line_manager_signature &&
                    this.renderSignature(report.line_manager_signature)}
                </div>

              </div>
            </>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            {this.state.editing && checkedit === "report-edit-jobpack" && (

              <Link
                to={this.props.location.pathname.replace(
                  "report-edit-jobpack",
                  "report-view"
                )}
              >
                <div>
                  <ActionButton
                    style={{ marginRight: 10 }}
                    onClick={() => {

                      this.props.setReport(
                        this.state.report,
                        this.props.location
                          .pathname
                      );
                    }}
                    variant="contained"
                    color="primary"
                  >
                    Submit
                                            </ActionButton>
                  <ActionButton
                    color="secondary"
                    variant="contained"
                  >
                    Cancel
                                            </ActionButton>
                </div>
              </Link>
            )}

            {!this.state.editing && checkedit === "report-view" && (
              <Link
                to={this.props.location.pathname.replace(
                  "report-view",
                  "report-edit-jobpack"
                )}
              >
                {/* <ActionButton
                                                variant="contained"
                                                color="primary"
                                            >
                                                Edit
                                        </ActionButton> */}
              </Link>
            )}
          </div>



          <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            {this.state.editing && checkedit === "report-edit" && (

              <Link
                to={this.props.location.pathname.replace(
                  "report-edit",
                  "report-view-standalone"
                )}
              >
                <div>
                  <ActionButton
                    style={{ marginRight: 10 }}
                    onClick={() => {

                      this.props.setReport(
                        this.state.report,
                        this.props.location
                          .pathname
                      );
                    }}
                    variant="contained"
                    color="primary"
                  >
                    Submit
                                            </ActionButton>
                  <ActionButton
                    color="secondary"
                    variant="contained"
                  >
                    Cancel
                                            </ActionButton>
                </div>
              </Link>
            )}

            {!this.state.editing && checkedit === "report-view-standalone" && (
              <Link
                to={this.props.location.pathname.replace(
                  "report-view-standalone",
                  "report-edit"
                )}
              >
                {/* <ActionButton
                                                variant="contained"
                                                color="primary"
                                            >
                                                Edit
                                        </ActionButton> */}
              </Link>
            )}
          </div>

          {report && (
            <Modal isOpen={this.state.imageModal}>
              <ModalHeader>Signature Image</ModalHeader>
              <ModalBody style={{ margin: "auto" }}>
                <img
                  src={
                    selectedImg === undefined ||
                      selectedImg === null ||
                      selectedImg === ""
                      ? noImg
                      : selectedImg
                  }
                  alt="Site"
                  style={{ width: "350px", height: "350px" }}
                />
              </ModalBody>
              <ModalFooter>
                <Button
                  variant="outlined"
                  onClick={() => {
                    this.setState({
                      selectedImg: false,
                      imageModal: false
                    });
                  }}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </CardContent>
      </Card>
    );
  }
}
export default connect(
  store => {
    return { report: selectReport(store) };
  },
  { getReport, setReport, getJobPackReports }
)(OfficeInspectionReport);
